module.exports = __webpack_public_path__ + "img/h5_P1.c6efecff.jpg";